import React from "react";
import { Formik, Form, Field } from "formik";
import ModalComponent from "../../../components/Modal";
import TextInput from "../../../components/TextInput";
import TextArea from "../../../components/TextArea";

const ViewRequirementModal = ({ show, onClose, initialValues, onEditClick }) => {
  return (
    <ModalComponent
      show={show}
      onClose={onClose}
      title="View Requirement"
    >
      <Formik
        initialValues={initialValues}
        enableReinitialize
      >
        {({ handleChange, values }) => (
          <Form className="max-h-[85vh] overflow-y-auto">
            <div className="mt-4" />
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div>
              <TextInput
                  value={values?.clientName || ""}
                  name="clientName"
                  placeholder="Client Name"
                  handleChange={handleChange}
                  type="text"
                  classes="w-full"
                  legend="Client Name"
                  disabled={true}
                />           
              </div>
              <div>
                <TextInput
                  value={values?.location || ""}
                  name="location"
                  placeholder="Location"
                  handleChange={handleChange}
                  type="text"
                  classes="w-full"
                  legend="Location"
                  disabled={true}
                />
              </div>
              
              <div>
                <TextInput
                  value={values?.position || ""}
                  name="position"
                  placeholder="Position"
                  handleChange={handleChange}
                  type="text"
                  classes="w-full"
                  legend="Position"
                  disabled={true}
                />
              </div>
              <div>
                <TextInput
                  value={values?.rate || ""}
                  name="rate"
                  placeholder="Rate"
                  handleChange={handleChange}
                  type="text"
                  classes="w-full"
                  legend="Rate"
                  disabled={true}
                />
              </div>
              <div>
                <TextInput
                  value={values?.source || ""}
                  name="source"
                  placeholder="Source"
                  handleChange={handleChange}
                  type="text"
                  classes="w-full"
                  legend="Source"
                  disabled={true}
                />
              </div>
              <div>
                <TextInput
                  value={values?.requirementDate || ""}
                  name="requirementDate"
                  placeholder="Requirement Date"
                  handleChange={handleChange}
                  type="text"
                  classes="w-full"
                  legend="Requirement Date"
                  disabled={true}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Status</label>
                <div className="flex items-center space-x-6">
                  <label className="flex items-center space-x-2">
                    <Field
                      type="radio"
                      name="stsCd"
                      value="A"
                      checked={values.stsCd === "A"}
                      className="text-blue-600 focus:ring-blue-500"
                      disabled
                    />
                    <span className="text-sm text-gray-700">Active</span>
                  </label>
                  <label className="flex items-center space-x-2">
                    <Field
                      type="radio"
                      name="stsCd"
                      value="D"
                      checked={values.stsCd === "D"}
                      className="text-blue-600 focus:ring-blue-500"
                      disabled
                    />
                    <span className="text-sm text-gray-700">Deactive</span>
                  </label>
                </div>
              </div>
              <div>
                <TextInput
                  value={values?.expiryDate || ""}
                  name="expiryDate"
                  placeholder="Expiry Date"
                  handleChange={handleChange}
                  type="text"
                  classes="w-full"
                  legend="Expiry Date"
                  disabled={true}
                />
              </div>
            </div>
            <div className="mt-4 sm:col-span-2">
              <TextArea
                value={values?.description || ""}
                name="description"
                placeholder="Description"
                handleChange={handleChange}
                classes="w-full"
                legend="Description"
                rows={4}
                disabled={true}
              />
            </div>
            <div className="mt-6 flex justify-end gap-3">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
              >
                Close
              </button>
              {onEditClick && (
                <button
                  type="button"
                  onClick={onEditClick}
                  className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                >
                  Edit
                </button>
              )}
            </div>
          </Form>
        )}
      </Formik>
    </ModalComponent>
  );
};

export default ViewRequirementModal;

